import { createUseStyles } from 'react-jss'
import { black, darkGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  providerColumn: {
    maxWidth: 24,
    marginRight: 16
  },
  campaignItem: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 32,
    '&:first-of-type': {
      marginTop: 24
    },
    '& p': {
      marginTop: 0,
      color: black
    }
  },
  campaignName: {
    marginBottom: 7
  },
  updateSuggestionRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: 16,
    rowGap: 4
  },
  arrowIcon: {
    '& path': {
      fill: darkGrey
    }
  },
  chipsWrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 10
  },
  actionButtons: {
    marginTop: 30,
    marginBottom: 64,
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    columnGap: 16
  }
})

export default useStyles
